module.exports = __webpack_public_path__ + "static/case_08-00955b24a4be4fb059ce1a49f9c7b410.jpg";